<template>
	<div class="md-layout-item">
		<md-card>
			<md-card-header class="md-card-header-icon md-card-header-blue">
				<div class="md-layout">
					<div class="md-layout-item">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fas', 'clipboard-list']"/>
						</div>
						<h4 class="title">{{ title }}</h4>
					</div>
					<div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                        <div class="flex items-center">
                            <div>
                                <md-button class="md-info md-sm md-datatable"
                                           @click="goToRoute(add.route)">
                                    <md-icon class="material-icons mr-1">add</md-icon>
                                    <span>{{ add.text }}</span>
                                </md-button>
                            </div>
                        </div>
					</div>
				</div>
			</md-card-header>
			<md-card-content class="mt-2">
				<md-table
					:value="queriedData"
					:md-sort.sync="currentSort"
					:md-sort-order.sync="currentSortOrder"
					:md-sort-fn="customSort"
					class="paginated-table table-hover"
				>
					<md-table-toolbar>
						<md-field>
							<label for="pages">Éléments à afficher</label>
							<md-select v-model="pagination.perPage" name="pages">
								<md-option
									v-for="item in pagination.perPageOptions"
									:key="item"
									:label="item"
									:value="item"
								>
									{{ item }}
								</md-option>
							</md-select>
						</md-field>

						<md-field>
							<md-input
								type="search"
								clearable
								style="width: 250px"
								placeholder="Rechercher..."
								v-model="searchQuery"
							>
							</md-input>
						</md-field>
					</md-table-toolbar>

					<md-table-row slot="md-table-row" slot-scope="{ item }">
						<md-table-cell md-label="#" md-sort-by="id">{{
								item.id
							}}</md-table-cell>
						<md-table-cell md-label="Nom" md-sort-by="name">{{
								item.name
							}}</md-table-cell>
						<md-table-cell md-label="">
							<md-button
								class="md-info md-simple"
								style="width: auto; padding: 0"
								@click="goToRoute(editRoute, item.id)"
							>
								Modifier
							</md-button>
						</md-table-cell>
					</md-table-row>
				</md-table>
				<div class="footer-table md-table">
					<table>
						<tfoot>
						<tr>
							<th
								v-for="item in this.$props.footer"
								:key="item.name"
								class="md-table-head"
							>
								<div class="md-table-head-container md-ripple md-disabled">
									<div class="md-table-head-label">
										{{ item }}
									</div>
								</div>
							</th>
						</tr>
						</tfoot>
					</table>
				</div>
			</md-card-content>
			<md-card-actions md-alignment="space-between">
				<div class="">
					<p class="card-category">
						Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ total }} éléments
					</p>
				</div>
				<pagination
					class="pagination-no-border pagination-info"
					v-model="pagination.currentPage"
					:per-page="pagination.perPage"
					:total="total"
				>
				</pagination>
			</md-card-actions>
		</md-card>
	</div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";

export default {
	name: "simple-datatable",
	components: {
		Pagination
	},
	props: {
		title: String,
		add: Object,
		editRoute: String,
		searchFields: Array,
		defaultSort: String,
		data: Array,
		footer: Array,
	},
	data() {
		return {
			currentSort: "name",
			currentSortOrder: "desc",
			pagination: {
				perPage: 50,
				currentPage: 1,
				perPageOptions: [50, 100, 150],
				total: 0
			},
			searchQuery: "",
			searchedData: [],
		};
	},
	computed: {
		/***
		 * Returns a page from the searched data or the whole data. Search is performed in the watch section below
		 */
		queriedData() {
			let result = this.$props.data;
			if (this.searchedData.length > 0) {
				result = this.searchedData;
			}
			return result.slice(this.from, this.to);
		},
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.total < highBound) {
				highBound = this.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		total() {
			return this.searchedData.length > 0
				? this.searchedData.length
				: this.$props.data.length;
		}
	},
	methods: {
		customSort(value) {
			const sortBy = this.currentSort;
			return value.sort((a, b) => {
				if (this.currentSortOrder === "desc") {
					if(sortBy === 'id') {
						if (a.id > b.id) {
							return 1;
						} else if (b.id > a.id) {
							return -1;
						}
						return 0;
					}
					return a[sortBy].localeCompare(b[sortBy]);
				}
				if(sortBy === 'id') {
					if (a.id > b.id) {
						return -1;
					} else if (b.id > a.id) {
						return 1;
					}
					return 0;
				}
				return b[sortBy].localeCompare(a[sortBy]);
			});
		},
		goToRoute(route, id = null) {
			this.$router.push({ name: route, params: { id } })
		},
	},
	watch: {
		/**
		 * Searches through the table data by a given query.
		 * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
		 * @param value of the query
		 */
		searchQuery(value) {
			let fuse = new Fuse(this.$props.data, {
				keys: this.$props.searchFields,
				threshold: 0.3
			});
			let result = this.$props.data;
			if (value !== "") {
				result = fuse.search(this.searchQuery);
			}
			this.searchedData = result;
		}
	}
}
</script>

<style scoped lang="scss">
.md-datatable::v-deep {
    max-height: 33px;
    min-height: 33px;
    width: 100%;

    .md-ripple {
        padding: 0 1rem !important;
    }
}

.md-layout-actions.md-layout-item {
    padding-right: 0;
}

::v-deep {
    .md-button-content {
        i {
            font-size: 1.1rem !important;
            height: 17px !important;
            width: 15px !important;
            min-width: 15px !important;
        }

        span {
            height: 17px;
            line-height: 18px;
        }
    }
}
</style>
